import React from "react";
import { Alert, AlertIcon } from "@chakra-ui/react";

const InstructionField = ({ field }) => (
  <Alert status="info" borderRadius="md">
    <AlertIcon />
    {field.helpText || field.description || field.label}
  </Alert>
);

export default InstructionField;
